import { render, staticRenderFns } from "./ques22.vue?vue&type=template&id=cdbdcc88&scoped=true"
import script from "./ques22.vue?vue&type=script&lang=js"
export * from "./ques22.vue?vue&type=script&lang=js"
import style1 from "./ques22.vue?vue&type=style&index=1&id=cdbdcc88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbdcc88",
  null
  
)

export default component.exports